/* go though the normal request service with token*/
import request from '@/utils/request.js'

export default {
    /**
     * 获取列表数据
     * @param {Object} [params={}] - 请求参数对象，默认为空对象。该对象将作为请求的数据部分发送到服务器。
     * @returns {Promise} - 返回一个Promise对象，该对象在请求成功时解析为服务器返回的数据，失败时则被拒绝。
     */
    lists(params = {}) {
      return request({
        url: 'api01/op01/',
        method: 'get',
        data: params
      })
    },

    incident(params = {}) {
      return request({
        url: 'api01/op03/',
        method: 'get',
        data: params
      })
    }
}